// extracted by mini-css-extract-plugin
export default {"headerContainer":"NoSectionsStackItems_headerContainer__9vNBd","augustRevisionSectionContainer":"NoSectionsStackItems_augustRevisionSectionContainer__GPswf"};